// extracted by mini-css-extract-plugin
export default {"modal":"WishListModal_modal__fBPyo","modalFooter":"WishListModal_modalFooter__Ey6MN"};